import React from 'react';
import { Button as SemanticButton, Icon } from "semantic-ui-react";
import PropTypes from "prop-types";
import ModuleConfiguration from "./model";

/** Render the inside of the button from the configuration */
function ButtonContent({
    configuration,
}) {
    if (configuration.btnIcon.active) {
        return <div className="btn-content">
            <Icon
                className="element"
                style={ { color: configuration.btnIcon.color } }
                name={ configuration.btnIcon.name || "send" }
            />
            <div className="element">{configuration.btnName}</div>
        </div>;
    }
    return configuration.btnName;
}

ButtonContent.propTypes = {
    configuration: PropTypes.instanceOf(ModuleConfiguration).isRequired,
};

export default function Button({
    configuration,
    sendStatus,
    isSmallScreen,
    ...props
}) {
    // follow the hovering of the button by the mouse
    const [hovered, setHovered] = React.useState(false);
    const onMouseOver = React.useCallback(() => setHovered(true), []);
    const onMouseOut = React.useCallback(() => setHovered(false), []);

    const style = React.useMemo(() => {
    // If sendStatus is true or false, (but not null), return the configuration
    // for a success or for failure
        if (sendStatus === true) {
            return configuration.btnValidationSuccess;
        } else if (sendStatus === false) {
            return configuration.btnValidationError;
        }

        // Return the hover configuration
        if(hovered) {
            return isSmallScreen ? configuration.btnDefaultSmallScreenHover : configuration.btnHover;
        }
        // Return the default configuration
        return isSmallScreen ? configuration.btnDefaultSmallScreen : configuration.btnDefault;

    }, [configuration, sendStatus, hovered, isSmallScreen]);

    return <SemanticButton
        { ...props }
        type="submit"
        style={ style }
        onMouseOver={ onMouseOver }
        onMouseOut={ onMouseOut }
    >
        {
            sendStatus !== undefined
                ? <Icon
                    style={ { color: '#FFFFFF' } }
                    name={ sendStatus ? "check" : "close" }
                />
                : <ButtonContent configuration={ configuration } />
        }
    </SemanticButton>;
}

Button.propTypes = {
    configuration: PropTypes.instanceOf(ModuleConfiguration).isRequired,
    sendStatus: PropTypes.bool,
    isSmallScreen: PropTypes.bool,
};
